export default {
  // 模块名称
  record: {
    // 按钮类
    button: {
      export: '导出',
      batchDel: '删除全部'
    },
    // 文字标签类
    label: {
    },
    // 提示类
    placeholder: {
    },
    // 消息类
    message: {
    },
    // 标题类
    title: {
    }
  }
}